const root = 'BusinessInformationForm'

export const TestId = {
  root,
  cardHeader: `${root}-cardHeader`,
  businessName: `${root}-businessName`,
  streetAddress: `${root}-streetAddress`,
  suiteApt: `${root}-suiteApt`,
  taxId: `${root}-taxId`,
  city: `${root}-city`,
  state: `${root}-state`,
  zipCode: `${root}-zipCode`,
  country: `${root}-country`,
  countrySelect: `${root}-country-countrySelect`,
  phoneNumber: `${root}-phoneNumber`,
  invoiceNote: `${root}-invoiceNote`,
  submitButton: `${root}-submitButton`,
  discardButton: `${root}-discardButton`,
}
